"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRegistrationStatusInitialState = void 0;
var _react = require("react");
const useRegistrationStatusInitialState = () => {
  const [finished, setFinished] = (0, _react.useState)(false);
  const [pendingRegistration, setPendingRegistration] = (0, _react.useState)(false);
  return {
    finished,
    setFinished,
    pendingRegistration,
    setPendingRegistration
  };
};
exports.useRegistrationStatusInitialState = useRegistrationStatusInitialState;